import { ref, query, orderByChild, limitToLast, startAt, get } from "firebase/database";
import { getDatabase } from "firebase/database";

const rootNode = 'cruzadinhas/covid/'
export default class ControleRank {

  constructor(firebase, auth) {
    //Carregando bibliotecas instanciadas no app central
    this.auth = auth //Autenticaca: auth.auth (firebase auth)
    this.firebase = firebase

    //Carregando base de dados 
    this.db = getDatabase(firebase);
    console.log(this.db);

    //Carregando nó raiz
    this.database = ref(this.db, rootNode + 'placar')

    //Controle
    this.controleRank = 0
    this.limiteRank = 5

    //Query de obtenção da lista de rank 
    this.consultarank = query(this.database, orderByChild('pontuacao'), limitToLast(this.limiteRank));
  }

  // Conectando Pai a atualização do filho
  ancora(forceUpdate) {
    this.forceUpdate = forceUpdate

  }
  update(item) {
    this.forceUpdate(item);
  }

  rank() {

    get(this.consultarank).then((snapshot) => {

      if (snapshot.exists()) {
        let flagUser = true
        snapshot.forEach((user) => {
          if (this.auth.auth.currentUser)
            if (user.key === this.auth.auth.currentUser.uid)
              flagUser = false
        })
        if (flagUser & this.auth.auth.currentUser) {
          this.rankUser(snapshot)


        } else
          this.ordernarRankBest(snapshot)

      } else {
        console.log("Vazio");
      }
    }).catch((error) => {
      console.error(error);
    });


  }

  rankUser(melhores) {
    get(query(this.database, orderByChild('pontuacao'), startAt(this.auth.usuario.rank.pontuacao))).then((snapshot) => {

      if (snapshot.exists()) {
        const userRankBetter =
        {
          "nick": this.auth.usuario.nick,
          "pontuacao": this.auth.usuario.rank.pontuacao,
          "tempo": this.auth.usuario.rank.tempo
          ,
          "ultimoAcesso": this.auth.usuario.rank.ultimoAcesso,
          "key": this.auth.usuario.user.uid,
          "posicao": snapshot.size


        }
        this.ordernarRank(melhores, userRankBetter)

      } else {
        console.log("ERRRRRRRO");
      }
    }).catch((error) => {
      console.error(error);
    });
  }


  ordernarRankBest(lista) {
    let rank = []
    lista.forEach((element) => {
      let item = element.val()
      item['key'] = element.key
      rank.push(item)
    })
    rank.sort(function (a, b) { return b['pontuacao'] - a['pontuacao'] });
    this.update(rank)
  }


  ordernarRank(lista, item) {
    let rank = []
    lista.forEach((element) => {
      let item = element.val()
      item['key'] = element.key
      rank.push(item)
    })
    if (item)
      rank.push(item)
    rank.sort(function (a, b) { return b['pontuacao'] - a['pontuacao'] });
    this.update(rank)
  }








}